'use client'

import React, { ReactNode, useRef, useEffect, useState } from 'react';
import ModalCloseButton from './ModalCloseButton';


interface ModalProps {
    title?: string;
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    className?: string;
    containerClassName?: string;
    windowClassName?: string;
    titleClassName?: string;
    closeOnOutsideClick?: boolean;
}

const Modal: React.FC<ModalProps> = (
    {
        isOpen,
        onClose,
        children,
        title,
        className,
        containerClassName,
        windowClassName,
        titleClassName,
        closeOnOutsideClick = true
    }
) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const [showModal, setShowModal] = useState(isOpen);
    const [isVisible, setIsVisible] = useState(isOpen);
	const [zIndex, setZIndex] = useState(100);


	let timer: NodeJS.Timeout;




	useEffect(() => {

		if (!(window as any).modalCount) {(window as any).modalCount = 0;}
		(window as any).modalCount += 1;
		setZIndex(100 + (window as any).modalCount);
	}, [])


    useEffect(() => {

        const handleOpenModal = () => {

			(window as any).modalCount += 10;
	        setZIndex(100 + (window as any).modalCount);

            const scrollPosition = window.scrollY;

            document.body.style.background = '#ff0000 !important';
            document.body.style.position = 'fixed !important';
            document.body.style.top = `-${scrollPosition}px  !important`;
            document.body.style.width = '100%  !important';

            return () => {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                window.scrollTo(0, scrollPosition);
            };
        };

        if (isOpen) {
            handleOpenModal();
        } else {
            //handleOpenModal()();
        }



        if (isOpen) {

            setShowModal(true);
            timer = setTimeout(() => setIsVisible(true), 10);
        } else {
			//(window as any).modalZindex -= 10;
            setIsVisible(false);
            timer = setTimeout(() => {
                setShowModal(false);
                onClose();
            }, 200);
        }

        return () => {
            if (timer) {
	            //(window as any).modalZindex -= 10;
                clearTimeout(timer);
            }
        };
    }, [isOpen, onClose]);

    const closeAnimation = () => {
        setIsVisible(false);
        setTimeout(() => {
            setShowModal(false);
            onClose();
        }, 200);
    }
    const handleCloseModal = (e: React.MouseEvent<HTMLDivElement>) => {
        if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
            closeAnimation();
        }
    };

    if (!showModal) return null;

	/*useEffect(() => {
		//const currentZIndex = (window as any).modalZindex ? (window as any).modalZindex  : 100;
		if (isVisible) {
			//(window as any).modalZindex = currentZIndex + 10;
			//setZIndex(currentZIndex + 10);
		} else {
			//(window as any).modalZindex = currentZIndex - 10;
			//setZIndex(currentZIndex - 10);
		}
	}, [])*/

    return (
        <div
            onClick={closeOnOutsideClick ? handleCloseModal : undefined}
            className={`fixed top-0 left-0 w-[100vw] h-[100vh] py-[100px] overflow-auto overscroll-none bg-gray-600 transition-all duration-200 ${isVisible ? 'bg-opacity-50' : 'bg-opacity-0'} ${containerClassName || ""}`}
            style={{zIndex: zIndex}}
        >
            <style>{`html { overflow: hidden !important; }`}</style>
            <div
                className={`relative flex flex-col justify-center items-center min-h-[calc(100vh-200px)] w-[100vw] transition-all duration-200 ${isVisible ? 'top-0 opacity-100' : 'top-[-50px] opacity-0'} ${windowClassName || ""}`}
            >
                <div
                    ref={modalRef}
                    className={`bg-white relative rounded-xl shadow-xl overflow-hidden flex flex-col  `}
                    style={{zIndex: zIndex}}
                >
                    <div className={`relative order-2 p-xl min-w-[400px] ${className || ""}`} style={{zIndex: "2"}}>
                        {children}
                    </div>
                    <div
                        className={`py-md pl-xl pr-md select-none shadow-xxl flex-row flex items-center relative order-1 ${titleClassName || ""}`}
                        style={{zIndex: 9999}}
                    >
                        {title && (
                            <div className={`flex flex-grow items-center text-title-lg flex-row h-full justify-start `}>
                                {title}
                            </div>
                        )}
                        <ModalCloseButton onClick={closeAnimation}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
